<template>
  <b-modal ref="modal" hide-footer centered no-close-on-backdrop>
    <template #modal-header="{ close }">
      <div class="modal-importar-sigtap__header">
        <h5 class="modal-title mb-0">Importar SIGTAP</h5>

        <div class="modal-importar-sigtap__actions">
          <modal-informacao
            :isIframe="true"
            urlIframe="https://doc.clickup.com/9011510980/d/h/8cj1fp4-1631/599ea88448ce3d9/8cj1fp4-9671"
          />

          <button
            type="button"
            class="close"
            aria-label="Close"
            :disabled="loading"
            @click="close()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </div>
    </template>

    <ValidationObserver ref="form">
      <validation-provider
        v-slot="{ errors, validate }"
        rules="required"
        name="rl_procedimento_registro"
      >
        <div class="form-group">
          <label>rl_procedimento_registro</label>

          <input
            ref="rl_procedimento_registro"
            type="file"
            class="form-control"
            accept=".txt,text/plain"
            @change="
              selecionarArquivo($event, 'rl_procedimento_registro', validate)
            "
          />

          <div v-if="errosArquivos.rl_procedimento_registro" class="error">
            {{ errosArquivos.rl_procedimento_registro }}
          </div>

          <div v-else-if="errors[0]" class="error">
            {{ errors[0] }}
          </div>
        </div>
      </validation-provider>

      <validation-provider
        v-slot="{ errors, validate }"
        rules="required"
        name="rl_procedimento_detalhe"
      >
        <div class="form-group mt-3">
          <label>rl_procedimento_detalhe</label>

          <input
            ref="rl_procedimento_detalhe"
            type="file"
            class="form-control"
            accept=".txt,text/plain"
            @change="
              selecionarArquivo($event, 'rl_procedimento_detalhe', validate)
            "
          />

          <div v-if="errosArquivos.rl_procedimento_detalhe" class="error">
            {{ errosArquivos.rl_procedimento_detalhe }}
          </div>

          <div v-else-if="errors[0]" class="error">
            {{ errors[0] }}
          </div>
        </div>
      </validation-provider>

      <!-- <validation-provider
        v-slot="{ errors, validate }"
        rules="required"
        name="tb_servico_classificacao"
      >
        <div class="form-group mt-3">
          <label>tb_servico_classificacao</label>

          <input
            ref="tb_servico_classificacao"
            type="file"
            class="form-control"
            accept=".txt,text/plain"
            @change="
              selecionarArquivo($event, 'tb_servico_classificacao', validate)
            "
          />

          <div v-if="errosArquivos.tb_servico_classificacao" class="error">
            {{ errosArquivos.tb_servico_classificacao }}
          </div>

          <div v-else-if="errors[0]" class="error">
            {{ errors[0] }}
          </div>
        </div>
      </validation-provider>

      <validation-provider
        v-slot="{ errors, validate }"
        rules="required"
        name="rl_procedimento_servico"
      >
        <div class="form-group mt-3">
          <label>rl_procedimento_servico</label>

          <input
            ref="rl_procedimento_servico"
            type="file"
            class="form-control"
            accept=".txt,text/plain"
            @change="
              selecionarArquivo($event, 'rl_procedimento_servico', validate)
            "
          />

          <div v-if="errosArquivos.rl_procedimento_servico" class="error">
            {{ errosArquivos.rl_procedimento_servico }}
          </div>

          <div v-else-if="errors[0]" class="error">
            {{ errors[0] }}
          </div>
        </div>
      </validation-provider> -->

      <div class="d-flex justify-content-end mt-4" style="gap: 10px">
        <button
          type="button"
          class="btn btn-secondary"
          :disabled="loading"
          @click="fechar"
        >
          Cancelar
        </button>

        <button
          type="button"
          class="btn btn-primary"
          :disabled="loading"
          @click="importar"
        >
          <span
            v-if="loading"
            class="spinner-border spinner-border-sm me-2"
          ></span>

          {{ loading ? 'Importando...' : 'Importar' }}
        </button>
      </div>
    </ValidationObserver>
  </b-modal>
</template>

<script>
import ModalInformacao from '@/components/ModalInformacao.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'

validations()

export default {
  name: 'ModalImportarSigtap',
  components: {
    ModalInformacao,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      arquivos: {
        rl_procedimento_registro: null,
        rl_procedimento_detalhe: null,
        // tb_servico_classificacao: null,
        // rl_procedimento_servico: null,
      },
      errosArquivos: {
        rl_procedimento_registro: '',
        rl_procedimento_detalhe: '',
        // tb_servico_classificacao: '',
        // rl_procedimento_servico: '',
      },
    }
  },
  methods: {
    /**
     * Abre o modal de importação do SIGTAP.
     *
     * @returns {void}
     */
    abrir() {
      this.limparArquivos()
      this.$refs.modal.show()
    },

    /**
     * Fecha o modal de importação do SIGTAP.
     *
     * @returns {void}
     */
    fechar() {
      this.$refs.modal.hide()
    },

    /**
     * Limpa os arquivos selecionados no modal.
     *
     * @returns {void}
     */
    limparArquivos() {
      this.arquivos = {
        rl_procedimento_registro: null,
        rl_procedimento_detalhe: null,
        // tb_servico_classificacao: null,
        // rl_procedimento_servico: null,
      }

      this.errosArquivos = {
        rl_procedimento_registro: '',
        rl_procedimento_detalhe: '',
        // tb_servico_classificacao: '',
        // rl_procedimento_servico: '',
      }

      this.$nextTick(() => {
        Object.keys(this.arquivos).forEach((tipoArquivo) => {
          const input = this.$refs[tipoArquivo]

          if (input) {
            input.value = ''
          }
        })

        this.$refs.form?.reset()
      })
    },

    /**
     * Seleciona e valida um arquivo do SIGTAP.
     *
     * Valida a extensão e o nome do arquivo de acordo
     * com o tipo de arquivo esperado.
     *
     * @param {Event} event Evento do input file
     * @param {String} tipoArquivo Tipo do arquivo SIGTAP
     * @param {Function} validate Função de validação do ValidationProvider
     * @returns {Promise<void>}
     */
    async selecionarArquivo(event, tipoArquivo, validate) {
      const arquivo = event.target.files[0]

      this.errosArquivos[tipoArquivo] = ''

      if (!arquivo) {
        this.arquivos[tipoArquivo] = null

        await validate(null)

        return
      }

      const nomeEsperado = `${tipoArquivo}.txt`
      const nomeArquivo = arquivo.name.toLowerCase()

      if (nomeArquivo !== nomeEsperado.toLowerCase()) {
        this.errosArquivos[
          tipoArquivo
        ] = `Arquivo inválido. Selecione o arquivo ${nomeEsperado}.`

        event.target.value = ''
        this.arquivos[tipoArquivo] = null

        await validate(null)

        return
      }

      this.arquivos[tipoArquivo] = arquivo

      await validate(arquivo)
    },

    /**
     * Valida e emite os arquivos selecionados para o componente pai.
     *
     * @returns {Promise<void>}
     */
    async importar() {
      const isValid = await this.$refs.form.validate()

      const possuiArquivoInvalido = Object.values(this.errosArquivos).some(
        (erro) => erro !== ''
      )

      if (!isValid || possuiArquivoInvalido) {
        return
      }

      this.$emit('importar', this.arquivos)
    },
  },
}
</script>

<style scoped lang="scss">
.modal-importar-sigtap__header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-importar-sigtap__actions {
  display: flex;
  align-items: center;
  gap: 15px;
}

.close {
  border: 0;
  background: transparent;
  font-size: 24px;
  line-height: 1;
  padding: 0;
  margin: 0;
}
</style>
